import React from 'react';
import { Form, Input, message, Modal } from 'antd';
import { ModelProviderVo, updateModelConfigProvider } from '@/api/model';

export interface EditProviderProp {
  data?: ModelProviderVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditProvider = ({ data, isEdit, updateFn, onCancel }: EditProviderProp) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    // 这里可以添加提交逻辑
    form.validateFields().then(values => {
      updateModelConfigProvider({ ...values, id: data?.id }).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal title={isEdit ? '编辑供应商' : '新增供应商'} open={true} onCancel={onCancel} onOk={onFinish} maskClosable={false}>
      <Form form={form} layout="vertical" initialValues={data}>
        <Form.Item name="apiKey" label="API Key" rules={[{ required: true, message: '请输入' }]}>
          <Input placeholder="在次输入您的API Key" />
        </Form.Item>
       
      </Form>
    </Modal>
  );
};

export default EditProvider;
